export enum EmployeeActionTypes {
    API_RESPONSE_SUCCESS = '@@employee/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@employee/API_RESPONSE_ERROR',

    ADD_EMPLOYEE = '@@employee/ADD_EMPLOYEE',
    EDIT_EMPLOYEE = '@@employee/EDIT_EMPLOYEE',
    GET_EMPLOYEE = '@@employee/GET_EMPLOYEE',
    GET_EMPLOYEES = '@@employee/GET_EMPLOYEES',
    RESET = '@@employee/RESET',
    RESET_SUCCESS = '@@employee/RESET_SUCCESS',
    RESET_ERROR = '@@employee/RESET_ERROR',
}
